import { createClient } from '@supabase/supabase-js';

// Get the user's active environment preference from LocalStorage
export const getActiveEnvMode = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    const savedMode = window.localStorage.getItem('leaf_env_mode');
    if (savedMode === 'test' || savedMode === 'stable') {
      return savedMode;
    }
  }
  
  // Fallback to hostname detection (for legacy/first-time URL entries)
  if (typeof window !== 'undefined' && window.location) {
    const hostname = window.location.hostname;
    if (hostname === 'test.leafandletter.site') return 'test';
    if (hostname === 'leafandletter.site') return 'stable';
  }
  
  return 'stable';
};

const getSupabaseUrl = (mode) => {
  if (mode === 'test') {
    return 'https://test.leafandletter.site/supabase';
  }
  if (mode === 'stable') {
    return 'https://leafandletter.site/supabase';
  }
  
  // Fallback to the environment variable for local development or mobile Capacitor builds
  return process.env.REACT_APP_SUPABASE_URL || 'http://localhost:8000';
};

const activeMode = getActiveEnvMode();
const supabaseUrl = getSupabaseUrl(activeMode);
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  }
});
